module.exports = __webpack_public_path__ + "static/media/ETH.946772ab.svg";